import styled from "styled-components";
import { colors } from "constants/colors";
import { BasicSectionContainer } from "../../../style";
import { styleSizes } from "constants/styleSizes";
import { sectionBackgroundStyles } from "screens/sectionBackgroundStyles";

export const ContactInfoSectionContainer = styled(BasicSectionContainer)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${colors.almostBlack};
  .noBr {
    white-space: nowrap;
  }
  .background {
    ${sectionBackgroundStyles}
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      display: none;
    }
  }

  .innerContainer {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 64px 32px;
    flex-direction: row;
    gap: 32px;

    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      flex-direction: row-reverse;
      padding: 48px 32px;
    }
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      flex-direction: column-reverse;
      padding: 24px 24px 0 24px;
    }
    .hForMobile {
      display: none;
      font-size: 18px;
      font-weight: 600;
      padding: 16px 0 32px 0;
      margin: 0;
      color: ${colors.almostBlack};
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        display: block;
      }
    }
  }

  .InfoSectionContainer {
    color: ${colors.almostBlack};

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    flex: 3;
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      flex: 1;
      width: 100%;
     }
    .info {
      width: 100%;
      max-width: 596px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        text-align: center;
      }
    }

    .infoTitle {
      font-size: 24px;
      font-weight: 700;
      padding: 0 0 16px 0;
      margin: 0;
      color: ${colors.almostBlack};
    }

    a {
      color: ${colors.almostBlack}!important;
      text-decoration: none;
      &:hover {
        color: ${colors.hoverBlue}!important;
      }
    }
  }

  .infoDescription {
    font-size: 16px;
    color: ${colors.almostBlack};
    line-height: 26px;
    margin-bottom: 60px;
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      margin-bottom: 16px;
      }
  }

  .infoDescriptionHours {
    font-size: 16px;
    color: ${colors.almostBlack};
    line-height: 26px;
    margin-bottom: 16px;
  }
  .infoDescriptionHoursTablet {
    max-width: 1229px;
    text-align: left;
    width: 100%;
    padding: 0 32px;
    display: none;
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      display: block;
      padding: 0 24px 24px 24px;
    }
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      padding: 0 24px;
      text-align: center;
    }
  }

  .infoDescriptionHoursDesktop {
    display: block;
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      display: none;
    }
    br {
      @media only screen and (max-width: 1220px) {
      display: none;
    }
    }
  }

  .MapSectionContainer {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex: 4;
    flex-direction: column;
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      flex: 7;
    }

    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      width: 100%;
    }

    iframe {
      width: 100%;
      max-width: 596px;
      height: 40vw;
      max-height: 443px;
      border: 1px solid ${colors.noBookingText}!important;

      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        border: 0 !important;
        height: 377px;
      }
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        height: 186px;
      }
    }
  }
`;
